import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  AbsoluteContainer,
  Cushion,
  MaxWidth,
  Rectangle,
  RelativeContainer,
  Typography,
} from '@pitchero/react-ui';
import Icon from '../icon';
import VideoMessage from '../activity-stream/video';
import Countdown from '../countdown';
import { Trans } from '../../lib/i18n';
import ClubRouter from '../../lib/routing';
import sanitizeParams from '../../lib/routing/sanitize-params';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import { getCurrentClub } from '../../store/clubs/selectors';

const countdownDefault = 5;

const NextVideo = ({ club, nextVideo, onClose, show }) => (
  <Rectangle fill="rgba(0,0,0,0.8)">
    <MaxWidth
      component="div"
      maxWidth={350}
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        opacity: show ? 1 : 0,
        transition: 'opacity 300ms ease-in-out',
      }}
    >
      <RelativeContainer style={{ overflow: 'hidden' }}>
        <Cushion all="medium">
          <Typography preset="tab--active" color="white" component="div">
            <Countdown
              start={show}
              duration={countdownDefault}
              onComplete={() => {
                ClubRouter.pushClubRoute(
                  club,
                  `media.video`,
                  sanitizeParams({ _title: nextVideo.title, id: nextVideo.video_id }),
                );
              }}
              render={(countdown) => (
                <>
                  <Trans i18nKey="media:watch_next" values={{ countdown }}>
                    Watch next
                  </Trans>
                  <Rectangle fill="primary">
                    <AbsoluteContainer
                      top={0}
                      left={show ? 0 : '-100%'}
                      style={{
                        height: 3,
                        width: '100%',
                        transition: `left linear ${countdownDefault}s`,
                      }}
                    />
                  </Rectangle>
                </>
              )}
            />
          </Typography>
          <VideoMessage
            key={nextVideo.id}
            message={nextVideo}
            stacked="never"
            messageType="video"
            titleColor="white"
            dateColor="white"
          />
        </Cushion>
        <AbsoluteContainer top={12} right={12} onClick={onClose} style={{ cursor: 'pointer' }}>
          <Icon name="cross" color="white" />
        </AbsoluteContainer>
      </RelativeContainer>
    </MaxWidth>
  </Rectangle>
);

NextVideo.propTypes = {
  club: CLUB_PROP_TYPES.isRequired,
  nextVideo: PropTypes.shape().isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};
export default connect((state) => ({
  club: getCurrentClub(state),
}))(NextVideo);
